// @ts-nocheck
import React, { useState } from "react";
import { toast } from "react-toastify";
import CancelIcon from "@mui/icons-material/Cancel";

const NearByLocation = ({
  edit,
  type,
  formData,
  errors,
  handleChange,
  optionsList,
  handleDropdownChange,
}) => {
  const [nearby, setNearby] = useState({ name: "", distance: "" });

  const handleLocAdd = () => {
    if (!nearby?.name) {
      toast.error("Enter Locations");
      return;
    }
    if (!nearby?.distance) {
      toast.error("Enter Distance");
      return;
    }
    handleDropdownChange("nearby_locations", [
      ...formData?.nearby_locations,
      nearby,
    ]);
    setNearby({ name: "", distance: "" });
  };

  const handleLocDelete = (location_del) => {
    let filtered = formData?.nearby_locations?.filter(
      (item) => item !== location_del
    );
    handleDropdownChange("nearby_locations", filtered);
  };
  console.log("near by", nearby);
  return (
    <div className="w-100">
      <div className="w-100 d-flex gap-5">
        <div className="col-md-5 ">
          <div className="d-flex ac-jb">
            <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Near By Locations<span style={{ color: "red" }}>*</span>
            </p>
            {edit && (
              <button
                disabled={!edit}
                onClick={() => {
                  handleLocAdd();
                }}
                className="add-btn p-1"
                style={{ width: "80px", height: "30px" }}
              >
                add
              </button>
            )}
          </div>
          <div className="d-flex gap-3 mt-3">
            <div>
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 sec">
                Location
              </p>
              <input
                className="input-box"
                name="propertyName"
                value={nearby?.name}
                readOnly={!edit}
                onChange={(e) =>
                  setNearby((prev) => ({ ...prev, name: e.target.value }))
                }
                type="text"
                placeholder="Location"
              />
              {errors.location && <p className="err">{errors.location}</p>}
            </div>
            <div>
              <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1 sec">
                Distance
              </p>
              <input
                className="input-box"
                name="propertyName"
                value={nearby?.distance}
                readOnly={!edit}
                onChange={(e) =>
                  setNearby((prev) => ({ ...prev, distance: e.target.value }))
                }
                type="number"
                placeholder="Distance"
              />
              {errors.location && <p className="err">{errors.distance}</p>}
            </div>
          </div>
        </div>
        <div className="col-md-5">
          <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
            Age<span style={{ color: "red" }}>*</span>
          </p>
          <select
            value={formData.age}
            disabled={!edit}
            onChange={handleChange}
            className="input-box"
            name="age"
            id=""
          >
            <option value={""}>select</option>
            {optionsList?.ageList?.map((item) => (
              <option value={item?.value}>{item?.label}</option>
            ))}
          </select>
          {errors.age && <p className="err">{errors.age}</p>}
        </div>
      </div>
      {formData?.nearby_locations?.length > 0 && (
        <ul className="d-flex gap-3 flex-wrap mt-3 w-100">
          {formData?.nearby_locations?.map((item, index) => {
            return (
              <li key={index}>
                <div
                  className="input-box d-flex ac-jb"
                  style={{ width: "200px", position: "relative" }}
                >
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 ">
                    {item.name}{" "}
                  </p>
                  <p className="f2 fs-sm-10 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-16 ">
                    {item.distance} km
                  </p>
                  {edit && (
                    <CancelIcon
                      onClick={() => handleLocDelete(item)}
                      style={{
                        position: "absolute",
                        top: "-8px",
                        right: "-10px",
                        height: "20px",
                      }}
                    />
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      )}
      <div className="w-100 mt-5">
        <p className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
          Description (optional)
        </p>
        <textarea
          className="roles-input w-100 p-2"
          name="description"
          value={formData.description}
          readOnly={edit ? false : true}
          onChange={handleChange}
          type="text"
          placeholder="Description.."
        />
        {errors.description && <p className="err">{errors.description}</p>}
      </div>
    </div>
  );
};

export default NearByLocation;
